/**
 * Created by danielr on 08-Jun-15.
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var template = require("manager-templates/data-sources/integrations/authentication/types/LPAuthView.tmpl");
    var InputField = require("ui/input-field/InputField");
    var LPAuthView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        LPAuthView = Marionette.ItemView.extend({
            template : template,
            withUIComponents : true,

            ui : {
                otk: ".otk",
                visitor: ".visitor"
            },

            uiComponents : {
                otkInput:{
                    type: InputField,
                    options:{
                        el:"view.ui.otk",
                        maxLength:ManagerConfig.dataSources.mainConfig.authenticationServer.MAX_LENGTH_FIELDS,
                        permutation: InputField.Permutation.B,
                        value: "view.model.getGeneratedKeyUrl"
                    },
                    events:{
                        change:"_onOtkInputChange"
                    }
                },
                visitorInput:{
                    type: InputField,
                    options:{
                        el:"view.ui.visitor",
                        maxLength:ManagerConfig.dataSources.mainConfig.authenticationServer.MAX_LENGTH_FIELDS,
                        permutation: InputField.Permutation.B,
                        value: "view.model.getKeyUrlValue"
                    },
                    events:{
                        change:"_onVisitorInputChange"
                    }
                }
            },

            initialize : function (options) {
                LEManager.logger.debug("LPAuthView:initialize");
            },

            setError:function(err){
                LEManager.logger.info("LPAuthView:setError");
                if (_.has(err, "genKeyUrl")){
                    this.uiComponents.otkInput.setError(true, err.genKeyUrl);
                }
                if (_.has(err, "valKeyUrl")){
                    this.uiComponents.visitorInput.setError(true, err.valKeyUrl);
                }
            },

            onValidatedInvalid:function (model, errors) {
                LEManager.logger.info("LPAuthView:onValidatedInvalid");
                this.setError(errors);
                LEManager.notifier.showError({content : LE.translator.translate("LEManager.manager.dataSources.authentication.server.input.invalid")});
            },

            onValidatedValid: function () {
                LEManager.logger.debug("LPAuthView:onValidatedValid");
                this.uiComponents.otkInput.setError(false, "");
                this.uiComponents.visitorInput.setError(false, "");
            },

            _onOtkInputChange: function(componentId, eventName, value){
                LEManager.logger.debug("LPAuthView:_onOtkInputChange");
                this.model.setGeneratedKeyUrl(value);
            },

            _onVisitorInputChange: function(componentId, eventName, value){
                LEManager.logger.debug("LPAuthView:_onVisitorInputChange");
                this.model.setKeyUrlValue(value);
            },

            onClose : function () {
                LEManager.logger.debug("LPAuthView:onClose");
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return LPAuthView;
});
